<template>
  <div>
    <h3 class="mb-1 subtitle-1">
      検収メモ
      <template v-if="mode == 'inspection'">
        <v-btn
          v-if="editComment == false"
          class="ml-2"
          color="primary"
          tile
          x-small
          outlined
          @click="startEditComment"
        >
          編集
        </v-btn>
        <v-btn
          v-if="editComment == true"
          class="ml-2"
          color="success"
          tile
          x-small
          outlined
          @click="updateComment"
        >
          保存
        </v-btn>
        <v-btn
          v-if="editComment == true"
          class="ml-2"
          color="warning"
          tile
          x-small
          outlined
          @click="editComment = false"
        >
          キャンセル
        </v-btn>
      </template>
    </h3>
    <div style="font-size: 0.6rem">※検収メモはライターには公開されません</div>
    <p v-if="editComment == false" class="mt-2">
      <span v-if="inspection.comment" class="">
        {{ inspection.comment }}
      </span>
      <span v-else class="caption"> 検収メモがありません </span>
    </p>
    <v-textarea
      v-if="editComment == true"
      v-model="editableComment"
      :value="inspection.comment"
      autofocus
      class="body-2"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    inspection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editComment: false,
      editableComment: ''
    }
  },
  computed: {
    ...mapState({
      mode: (state) => state.PostEditor.mode
    })
  },
  methods: {
    startEditComment () {
      this.editableComment = this.inspection.comment
      this.editComment = true
    },
    updateComment () {
      const payload = {
        inspectionId: this.inspection.id,
        inspectionAttributes: {
          comment: this.editableComment
        }
      }
      this.$store.dispatch('PostEditor/updateInspection', payload)
      this.editComment = false
    }
  }
}
</script>
